<template>
    <div class="morda-lenta-buy-fund">
        <button @click="checkWelcome" class="morda-lenta-buy">
            {{ $t("mordaLenta.mordaLntaBuy")
            }}<span>
                {{ $t("mordaLenta.mordaLntaBuySpan") }}
            </span>
        </button>
        <div class="morda-lenta-fund">
            <div @click="$modal.show('morda-lenta-gifts')" class="link-inherit">
                {{ $t("mordaLenta.mordaLentaButtonFund") }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "mordaLentaButtonFund",
    props: {
        i18n: Object,
    },
    computed: {
        ...mapGetters({
            isEmpty: "user/isEmpty",
            mordaLentaFund: "mordaLenta/fetchMordaLentaFund",
        }),
    },
    methods: {
        checkWelcome() {
            if (this.isEmpty("user")) {
                this.$modal.show("welcome");
            } else {
                this.$modal.show("morda-lenta-buy");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/layout/_morda-lenta-buy-fund";
</style>
